// Third Party
import * as React from 'react';
import { twMerge } from 'tailwind-merge';

// Utils
import { WithChildrenCommonProps } from '@types';
import { getFieldContainerStylesAsClassName } from './field-container-styles';

export interface IFieldContainerProps {
  /** When the container is focused */
  isFocused?: boolean;
  /** Flag to indicate whether the field is disabled */
  disabled?: boolean;
  /** Flag to indicate whether the field has an invalid value */
  isInvalid?: boolean;
  /** Flag to indicate whether it is a readonly field */
  readOnly?: boolean;
  /** Flag to indicate whether the field has a border */
  hasBorder?: boolean;
  /** Flag to indicate whether the field has a caret */
  hasCaret?: boolean;
  /** String to assign a role  */
  role?: string;
}

export type FieldContainerProps = WithChildrenCommonProps<IFieldContainerProps>;

export const FieldContainer = React.forwardRef(
  (
    props: FieldContainerProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    const {
      isFocused = false,
      children,
      disabled = false,
      isInvalid = false,
      readOnly = false,
      hasBorder = true,
      hasCaret = true,
      className: classNameProp,
      ...rest
    } = props;

    const twClassName = twMerge(
      getFieldContainerStylesAsClassName(
        disabled,
        isFocused,
        isInvalid,
        readOnly,
        hasBorder,
        hasCaret
      ),
      classNameProp
    );

    return (
      <div ref={ref} className={twClassName} {...rest}>
        {children}
      </div>
    );
  }
);

FieldContainer.displayName = 'FieldContainer';
